export default "__VITE_ASSET__BMEHOdYn__"